import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { getFeatureFlagOutsideOfReactLifecycleHelper } from '@seek/candidate-feature-flag';

import type createStore from 'src/store/createStore';
import { selectFeatureFlagOverrides } from 'src/store/selectors';

export const getFeatureFlagWithOverridesHelper = ({
  apolloClient,
  store,
}: {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  store: ReturnType<typeof createStore>;
}) =>
  getFeatureFlagOutsideOfReactLifecycleHelper({
    apolloClient,
    overridesGetter: () => selectFeatureFlagOverrides(store.getState()) || {},
  });
